import React, { type PropsWithChildren } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet, View } from 'react-native';
import {
  BodyText,
  Container,
  DisplayText,
  theme,
  TitleText,
  useResponsive,
} from '@sg/garnish';

const LoyaltyHomeHowItWorksContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  return (
    <View style={styles.background}>
      <Container
        style={match([
          styles.containerSM,
          styles.containerSM,
          styles.containerLG,
        ])}
      >
        <DisplayText
          style={[styles.kaleText, styles.centerText]}
          sizeMatch={['48']}
        >
          <FormattedMessage {...messages.title} />
        </DisplayText>

        <View style={styles.content}>{props.children}</View>
      </Container>
    </View>
  );
};

const LoyaltyHomeHowItWorksCard = (props: CardProps) => {
  const { index, title, description } = props;

  return (
    <View style={styles.card}>
      <TitleText sizeMatch={['24']} style={styles.index}>
        {index}
      </TitleText>

      <TitleText
        style={[styles.kaleText, styles.centerText]}
        sizeMatch={['32', '32', '48']}
      >
        {title}
      </TitleText>

      <BodyText style={styles.centerText} sizeMatch={['14', '14', '22']}>
        {description}
      </BodyText>
    </View>
  );
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'How it works',
    description: 'Loyalty Home | How it works | Title',
  },
});

// ─── Styles ─────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  background: {
    flexGrow: 1,
    height: 'auto',
    backgroundColor: theme.colors.SWEET_CORN,
  },
  containerSM: {
    paddingHorizontal: theme.spacing['6'],
    paddingVertical: theme.spacing['20'],
    gap: theme.spacing['10'],
  },
  containerLG: {
    paddingHorizontal: theme.spacing['30'],
    paddingVertical: theme.spacing['20'],
    gap: theme.spacing['10'],
  },
  content: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  card: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: theme.spacing['6'],
    paddingHorizontal: theme.spacing['16'],
    gap: theme.spacing['4'],
  },
  index: {
    width: 32,
    height: 32,
    lineHeight: 32,
    borderRadius: 32,
    borderWidth: 2,
    textAlign: 'center',
    color: theme.colors.KALE,
    borderColor: theme.colors.KALE,
  },
  kaleText: {
    color: theme.colors.KALE,
  },
  centerText: {
    textAlign: 'center',
  },
});

// ─── Types ──────────────────────────────────────────────────────────────────

type CardProps = {
  index: number;
  title: string;
  description: string;
};

// ─── Compound Components ────────────────────────────────────────────────────

export const LoyaltyHomeHowItWorks = {
  Container: LoyaltyHomeHowItWorksContainer,
  Card: LoyaltyHomeHowItWorksCard,
};
